import { graphql } from 'react-apollo';
import { LoggedInUserQuery, LogoutMutation } from './queries';
import { LogoutPayload } from './types';

export interface LogoutProps {
    logout: () => Promise<any>;
}

/** Provides components with a logout function */
export default graphql<any, LogoutPayload, {}, LogoutProps>(LogoutMutation, {
    props: ({ mutate }) => ({
        logout: async () => {
            if (!mutate) {
                throw new Error('No mutate function provided');
            }
            await mutate({
                refetchQueries: [{ query: LoggedInUserQuery }]
            });

            // Redirect the user to the home page, which will also nuke the apollo cache
            window.location.href = '/';
        }
    })
});



// WEBPACK FOOTER //
// ./src/client/components/Login/withLogout.tsx